import { ConciliationApi } from '../../Services/ConciliationApiDataService';

export const downloadConciliationCsv = async (type, filter, getToken) => {
  const token = await getToken();
  const blob = await ConciliationApi.exportConciliationCsv(type, filter, token);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `conciliacion-${type}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
